import { ITranslations } from 'types/common';
import en from 'translations/en/pointsCategoriesTable.json';
import pl from 'translations/pl/pointsCategoriesTable.json';
import sl from 'translations/sl/pointsCategoriesTable.json';
import { PointsCategoriesTableTransFields } from './types';

export const pointsCategoriesTableTranslations: ITranslations<PointsCategoriesTableTransFields> = {
  name: 'pointsCategoriesTable',
  en,
  pl,
  sl,
};
